import { ContextPack } from "@/api/studio/contexts/types/context.type";
import { Card, CardBadge } from "@/components/ui/card";
import ENV from "@/utils/env";

/* Prop Types */
interface ContextDropzonePreviewProps {
  assetIndex: number;
  contextPack: ContextPack;
}

/*
 * ContextDropzonePreview component
 */
export const ContextDropzonePreview = ({ assetIndex, contextPack }: ContextDropzonePreviewProps) => {
  /* Render */
  return (
    <>
      {/* Prev context */}
      {assetIndex > 0 && (
        <Card
          size="small"
          imgFit="contain"
          imageUrl={`${ENV.API_PLATFORM_URL}/v3/contexts/${contextPack?.contexts[assetIndex - 1].id}/image?maxWidth=162&maxHeight=116`}
          className="min-w-[162px] cursor-auto opacity-60"
        >
          {contextPack?.contexts[assetIndex - 1].dropzone.points.length > 0 && <CardBadge className="bg-primary top-2 right-2 border-0">Added</CardBadge>}
        </Card>
      )}

      {/* Current context */}
      <Card
        size="small"
        imgFit="contain"
        imageUrl={`${ENV.API_PLATFORM_URL}/v3/contexts/${contextPack?.contexts[assetIndex].id}/image?maxWidth=162&maxHeight=116`}
        selected={true}
        className="min-w-[162px] cursor-auto"
      >
        {contextPack?.contexts[assetIndex].dropzone.points.length > 0 && <CardBadge className="bg-primary top-2 right-2 border-0">Added</CardBadge>}
      </Card>

      {/* Next context */}
      {assetIndex < contextPack.contextCount - 1 && (
        <Card
          size="small"
          imgFit="contain"
          imageUrl={`${ENV.API_PLATFORM_URL}/v3/contexts/${contextPack?.contexts[assetIndex + 1].id}/image?maxWidth=162&maxHeight=116`}
          className="min-w-[162px] cursor-auto opacity-60"
        >
          {contextPack?.contexts[assetIndex + 1].dropzone.points.length > 0 && <CardBadge className="bg-primary top-2 right-2 border-0">Added</CardBadge>}
        </Card>
      )}
    </>
  );
};
